<template>
    <v-btn text block tile color="secondary" class="caption point-btn" height="54px" v-bind="{ to }">
        <slot />
    </v-btn>
</template>

<script>
export default {
    props: {
        value: { type: Object, default: () => ({}) }, // user-point-order
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        to() {
            const { _id: _order, _user } = this.value;

            return {
                path: "/console/user-points",
                query: { _user, _order },
            };
        },
    },
};
</script>


<style lang="scss" scoped>
.point-btn {
    ::v-deep {
        .v-btn__content {
            display: block;
            text-align: initial;
            white-space: pre-line;
            text-transform: initial;
        }
    }
}
</style>